var React = require('react');

function YachtCharters (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M1 23a9.731 9.731 0 0 0 7.5-3.5 9.786 9.786 0 0 0 15 0A9.676 9.676 0 0 0 31 23M1 14a9.731 9.731 0 0 0 7.5-3.5 9.786 9.786 0 0 0 15 0A9.676 9.676 0 0 0 31 14M1 5a9.731 9.731 0 0 0 7.5-3.5A9.737 9.737 0 0 0 16 5a9.676 9.676 0 0 0 7.5-3.5A9.676 9.676 0 0 0 31 5"}))));
}

YachtCharters.defaultProps = {"width":"32","height":"24","viewBox":"0 0 32 24"};

module.exports = YachtCharters;

YachtCharters.default = YachtCharters;
